import { render, staticRenderFns } from "./sys-common-group.vue?vue&type=template&id=1378560e&scoped=true"
import script from "./sys-common-group.vue?vue&type=script&lang=js"
export * from "./sys-common-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1378560e",
  null
  
)

export default component.exports